import { SortDirection } from '@angular/material/sort';

import {
  MY_DEMANDS_DEFAULT_PAGE,
  MY_DEMANDS_DEFAULT_PAGE_SIZE,
  MY_DEMANDS_DEFAULT_PLATFORM,
  MY_DEMANDS_DEFAULT_REQUESTED_FROM,
  MY_DEMANDS_DEFAULT_REQUESTED_TO,
  MY_DEMANDS_DEFAULT_SUBJECT_TAB,
  MY_DEMANDS_STATUS_FILTER_MAP,
  MY_DEMANDS_STATUS_FILTERS,
  MY_DEMANDS_SUBJECT_TABS,
  MyDemandsStatusFilter,
  MyDemandsSubjectTab,
} from './list-my-demands.const';

export type MyApprovalsTab = 'awaiting' | 'acted' | 'all';

export const MY_APPROVALS_TABS: ReadonlyArray<MyApprovalsTab> = ['awaiting', 'acted', 'all'];

export const MY_APPROVALS_DEFAULT_TAB: MyApprovalsTab = 'awaiting';
export const MY_APPROVALS_DEFAULT_PAGE = MY_DEMANDS_DEFAULT_PAGE;
export const MY_APPROVALS_DEFAULT_PAGE_SIZE = MY_DEMANDS_DEFAULT_PAGE_SIZE;

export const MY_APPROVALS_DEFAULT_ORDER_BY = 'created_at';
export const MY_APPROVALS_DEFAULT_ORDER: SortDirection = 'desc';
export const MY_APPROVALS_ORDER_BY_VALUES: ReadonlyArray<string> = [
  'subject',
  'reference',
  'requester',
  'status',
  'created_at',
];
export const MY_APPROVALS_ORDER_VALUES: ReadonlyArray<SortDirection> = ['asc', 'desc'];

export type MyApprovalsStatusFilter = MyDemandsStatusFilter;
export const MY_APPROVALS_STATUS_FILTERS = MY_DEMANDS_STATUS_FILTERS;
export const MY_APPROVALS_STATUS_FILTER_MAP = MY_DEMANDS_STATUS_FILTER_MAP;

export const MY_APPROVALS_DEFAULT_REQUESTED_FROM = MY_DEMANDS_DEFAULT_REQUESTED_FROM;
export const MY_APPROVALS_DEFAULT_REQUESTED_TO = MY_DEMANDS_DEFAULT_REQUESTED_TO;
export const MY_APPROVALS_DEFAULT_PLATFORM = MY_DEMANDS_DEFAULT_PLATFORM;
export const MY_APPROVALS_DEFAULT_DELEGATED = false;

export type MyApprovalsSubjectType = MyDemandsSubjectTab;
export const MY_APPROVALS_SUBJECT_TYPES = MY_DEMANDS_SUBJECT_TABS;
export const MY_APPROVALS_DEFAULT_SUBJECT_TYPE = MY_DEMANDS_DEFAULT_SUBJECT_TAB;
